import script from "./Loader.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loader.vue?vue&type=script&setup=true&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=0f00fe96&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f00fe96"]])

export default __exports__